<template>
  <div
    class="text-body-2 text-secondary--text"
    data-qa="analyses_meta_h1_subtitle"
  >
    <template v-if="!equipOpenType">
      Где сделать
    </template>
    {{ serviceNameVin }}
    <template v-if="equipOpenType">
      открытого типа
    </template>
    {{ locationText }}:
    {{ totalObjects }}
    {{ clinicsWord }}
    с адресами
    <template v-if="hasPrice">
      и ценами
      от <span itemprop="lowPrice">{{ priceMin }}</span>
      до <span itemprop="highPrice">{{ priceMax }}</span>
      <span
        itemprop="priceCurrency"
        :content="currencyIso"
      > {{ currencyGenitive }}</span>,
    </template>
    запись на {{ serviceNameVin }}, фотографии и характеристики оборудования.
    При выборе клиники можно ознакомиться с отзывами других пациентов,
    которые уже воспользовались услугами
    "{{ serviceName }}"
    в данных медицинских центрах {{ townNameRod }}.
  </div>
</template>

<script setup lang="ts">
import declensionByNum from 'src/utils/declensionByNum'
import getRuPredlog from 'src/utils/getRuPredlog'
import useContextStore from 'src/store/useContextStore'
import type { AnalysesPageContext } from 'src/components/pages/[town-translit]/diagnostika/analiz/_types'
import type { CommonContextStore } from 'src/types/context'

const { context } = useContextStore() as CommonContextStore & {
  context: AnalysesPageContext
}

const equipOpenType = Boolean(context.equip_open_type)
const totalObjects = context.total_objects ?? 0
const {
  town,
  service_category: serviceCategory,
  service_class: serviceClass,
  lpu_cards_service_aggregated_data: aggregatedData,
  metro,
  district,
} = context

const serviceNameVin = serviceCategory?.name_vin || serviceClass.name_vin
const serviceName = serviceCategory?.name || serviceClass.name

const priceMin = aggregatedData?.price_min
const priceMax = aggregatedData?.price_max
const hasPrice = priceMin != null

const clinicsWord = declensionByNum(totalObjects, ['клиника', 'клиники', 'клиник'])

const currencyIso = context.currency.iso
const currencyGenitive = context.currency?.name_short_plural_genitive?.toLowerCase()

const getTownNameRod = (value: { translit: string, name_rod: string }) => (
  value.translit === 'spb' ? 'СПб' : value.name_rod
)

const getTownNamePredWithPreposition = (value: { translit: string, name_pred: string }) => {
  const townName = value.translit === 'spb' ? 'СПб' : value.name_pred

  return `${getRuPredlog(townName, 'в')} ${townName}`
}

const getLocationText = () => {
  if (metro?.name) {
    return `на метро ${metro.name}, ${town.name}`
  }

  if (district) {
    const districtLocation = district.name_pred
      ? `${getRuPredlog(district.name_pred, 'в')} ${district.name_pred}`
      : `в ${district.name}`

    return `${districtLocation} ${getTownNameRod(town)}`
  }

  return getTownNamePredWithPreposition(town)
}

const locationText = getLocationText()

const townNameRod = town.name_rod
</script>
